import React from 'react'
import { Utils } from '../utils/Utils';

function AgePlayersStats(teams) {

  const getAgePlayersStats = () => {
    return Array.from(teams.teams
      .flatMap(team => team.players))
      .filter(player => player !== undefined)
      .map(player => ({
        name: player.name,
        photo: player.urlPhoto,
        nameText:  '<img class="photo" src="'+player.urlPhoto+'" alt="'+player.urlPhoto+'"></img>&nbsp;' + player.name,
        age: Utils.getDecimalAge(player.birthDate),
        ageText: Utils.getAge(player.birthDate) + ' años'
      }))
      .sort((a, b) => {
        return b.age - a.age;
      })
  }

  const getTopAgePlayersStats = () => {
    return getAgePlayersStats().slice(0, 6);
  }
  const getBottomAgePlayersStats = () => {
    return getAgePlayersStats().sort((a, b) => {
      return a.age - b.age;
    }).slice(0, 6);
  }

  const getAverageAge = () => {
    const ages = getAgePlayersStats().map(player => player.age);
    const totalAge = ages.reduce((sum, age) => sum + age, 0);
    return (totalAge / ages.length).toFixed(2);
  }

  return (
    <div>
      <p>Edad media de los jugadores: {getAverageAge()} años</p>
      <p><b>Jugadores con mayor edad</b></p>
      <table className="table-stats">
        <thead>
          <tr>
            <th>Jugador</th>
            <th>Edad</th>
          </tr>
        </thead>
        <tbody>
        {getTopAgePlayersStats().map((item, index) => (
            <tr key={index}>
              <td><div className="label-player" dangerouslySetInnerHTML={{ __html: item.nameText }}></div></td><td className="td-value"> {item.ageText}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p><b>Jugadores con menor edad</b></p>
      <table className="table-stats">
        <thead>
          <tr>
            <th>Jugador</th>
            <th>Edad</th>
          </tr>
        </thead>
        <tbody>
        {getBottomAgePlayersStats().map((item, index) => (
            <tr key={index}>
              <td><div className="label-player" dangerouslySetInnerHTML={{ __html: item.nameText }}></div></td><td className="td-value"> {item.ageText}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default AgePlayersStats